<div class="input-group fiori3-input-group flex-column" [class.info-shown]="infoMessage">
  <div class="flex">
    @if (label) {
      <label [ngStyle]="{'display' : infoMessage ? 'inline-block' : 'block'}">
        {{label.key | translate}}
      </label>
    }
    @if (infoMessage) {
      <cpq-info class="cpq-info-icon float-right" [message]="infoMessage" (onInfoClick)="infoClicked()"></cpq-info>
    }
  </div>
  <textarea #textarea id="{{name}}" [disabled]='disabled' [rows]='rows' name="{{name}}" class="form-control long-text" [ngClass]="{ 'ng-invalid': control?.errors && control?.touched, 'ng-valid': control?.valid }" [(ngModel)]="value" placeholder="{{ placeholderMsg }}" (blur)="touched($event)" (resize)="onResize($event)">
  </textarea>
  <show-errors [control]='control'></show-errors>
  @if (config) {
    <span #formulaBuilder class="formula-builder">
      <button type="button" [attr.id]="name ? name + '_FormulaBuilder' : 'formulaBuilder'" class="btn btn-link button-link" (click)="openFormulaBuilder(value)" [disabled]='control.disabled'>
        <span class="sap-icon">&#xe19f;</span>
        @if (!config.hideLabel) {
          {{'FormulaBuilder.Title' | translate}}
        }
      </button>
    </span>
  }
</div>